import type { QueryClient } from '@tanstack/react-query';
import type { RouteObject } from 'react-router';

import { createBrowserRouter } from 'react-router';

import { loader as appointmentsDrilldownLoader } from './AppointmentsDrilldown/AppointmentsDrilldown.data.ts';
import { AppointmentsDrilldown } from './AppointmentsDrilldown/AppointmentsDrilldown.tsx';
import { loader as formsDrilldownLoader } from './FormsDrilldown/FormsDrilldown.data.ts';
import { FormsDrilldown } from './FormsDrilldown/FormsDrilldown.tsx';
import {
  loader as homeLoader,
  shouldRevalidate as homeShouldRevalidate,
} from './Home/Home.data.ts';
import { Home } from './Home/Home.tsx';
import { LayoutError, Layout } from './Layout.tsx';
import { loader as loginLoader } from './Login/Login.data.ts';
import { Login } from './Login/Login.tsx';
import { Unauthorized } from './Unauthorized.tsx';

function getRoutes(queryClient: QueryClient): RouteObject[] {
  return [
    {
      element: <Layout />,
      errorElement: <LayoutError />,
      children: [
        {
          path: '/',
          element: <Home />,
          loader: homeLoader(queryClient),
          shouldRevalidate: homeShouldRevalidate,
          children: [
            {
              path: '/appointments/drilldown',
              element: <AppointmentsDrilldown />,
              loader: appointmentsDrilldownLoader(queryClient),
            },
            {
              path: '/forms/drilldown',
              element: <FormsDrilldown />,
              loader: formsDrilldownLoader(queryClient),
            },
          ],
        },
        {
          path: '/login',
          element: <Login />,
          loader: loginLoader,
        },
        {
          path: '/unauthorized',
          element: <Unauthorized />,
        },
      ],
    },
  ];
}

export const createRouter = (queryClient: QueryClient) =>
  createBrowserRouter(getRoutes(queryClient));
